import React, { useState, useEffect, useRef, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
  Box,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Text,
  HStack,
  VStack,
  Grid,
  Card,
  CardBody,
  CardHeader,
  Spinner
} from '@chakra-ui/react';
import DatePicker from "react-datepicker";
import { CalendarIcon } from '@chakra-ui/icons';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import grab from '../../utils/grab';
import { useAtom } from 'jotai';
import { userAtom } from './../../atoms';
import AccountDetails from './selectedAccount';
import { useNavigate } from 'react-router-dom';


function Accounts() {
  const [rowData, setRowData] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [searching, setSearhing] = useState(false);
  const gridApi = useRef(null);
  const gridRef = useRef(null);
  const [selectedAccountData, setSelectedAccountData] = useState(null);
  const navigate = useNavigate();

  const [user, setUser] = useAtom(userAtom);
  const saveTimeoutRef = useRef(null);

  const current = new Date();
  current.setHours(0,0,0,0);
  const nextDay = new Date(current);
  nextDay.setDate(nextDay.getDate() + 1);

  const [startDate, setStartDate] = useState(current);
  const [endDate, setEndDate] = useState(nextDay);

  useEffect(() => {
    if (user.locationId){
      fetchData();
    }


  }, [user.locationId]);

  const fetchData = async () => {
    try {
      setSearhing(true)
      const response = await grab.get(`/accounts`, {
        params: {
          locationId: user.locationId
        }
      });
      setRowData(response.data);

    } catch (error) {
      setSearhing(false)
      console.error('Error fetching data:', error);
    }
    finally {
      setSearhing(false)

    }
  };

  const handleSearch = () => {
    fetchData();
  };

  const columnDefs = [
    { headerName: "Name", field: "Name" },
    { headerName: "Account Number", field: "AccountNum" },
    { headerName: "Last Delivery Date", field: "LastDeliveryDate" },
    { headerName: "Last Delivery Quantity", field: "LastDeliveryQty" },
    { headerName: "Delivery City", field: "DeliveryCity" },
    { headerName: "Delivery Zip", field: "DeliveryZip" },
    { headerName: "Delivery State", field: "DeliveryState" }
  ];




  const saveGridState = () => {
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current); // Clear existing timeout if present
    }

    // Set a new timeout to save the grid state after 2 seconds
    saveTimeoutRef.current = setTimeout(() => {
      if (gridRef.current) {
        const columnState = gridRef.current.columnApi.getColumnState();
        const columnGroupState = gridRef.current.columnApi.getColumnGroupState();
        const filterState = gridApi.current.getFilterModel();
        const gridState = { columnState, columnGroupState, filterState };
        localStorage.setItem('accountssssFleetGridState', JSON.stringify(gridState));
        console.log('grid saved');
      } else {
        console.warn('getColumnState is not a function');
      }
    }, 1000);
  };

  const defaultColDef = useMemo(() => {
    return {
      cellStyle: { 'textAlign': 'left' },
      menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
      filter: true,
      sortable: true,
      resizable: true,
      enableRowGroup: true,
      width: 200
    }
  }, []);

  // Load the grid's saved state
  const loadGridState = () => {
    const savedState = localStorage.getItem('accountssssFleetGridState');
    console.log(savedState)
    if (savedState) {
      const gridState = JSON.parse(savedState);
      console.log('loading state')
      gridRef.current.columnApi.applyColumnState({ state: gridState.columnState, applyOrder: true});
      gridRef.current.columnApi.setColumnGroupState(gridState.columnGroupState);
      gridApi.current.setFilterModel(gridState.filterState);
      console.log('loading state')
    }
  };

  const onGridReady = params => {
    gridApi.current = params.api;
    loadGridState(); // Load the saved grid state
  };

    const handleSelectionChange = () => {
        const selectedRows = gridApi.current.getSelectedRows();
        console.log(selectedRows[0])
        setSelectedAccountData(selectedRows[0]);
        navigate(`${selectedRows[0].AccountNum}`);
    };

  const DateInput = React.forwardRef(({ value, onClick }, ref) => (
    <InputGroup>
    <InputLeftElement
      pointerEvents="none"
      children={<CalendarIcon color="gray.400" />}
    />
    <Input
      onClick={onClick}
      value={value}
      ref={ref}
      placeholder="Select date"
    />
  </InputGroup>
  ));

  return (
    <Box width={'100%'} height={'100%'}>
        {selectedAccountData ?
        <AccountDetails selectedAccountData={selectedAccountData}  setSelectedAccountData={setSelectedAccountData}/>
        :

        <Grid templateColumns={showFilters ? { base: '1fr', md: '8fr 2fr' } : { base: '1fr' }} gap={3} minH="100vh">

        <Card width={"100%"} height={'100%'} minH='500px'>
          <CardHeader>
            <HStack justify={'space-between'}>
              <Text fontSize="xl" fontWeight="bold">
                Accounts
              </Text>
              <Button onClick={()=> showFilters ? setShowFilters(false) : setShowFilters(true)} colorScheme="blue" mt={3}>
                  {showFilters ? 'Hide Filter' : 'Show Filter'}
              </Button>
            </HStack>
          </CardHeader>
          <CardBody>
            <Box className="ag-theme-alpine" width={"100%"} height={'100%'}>
              <AgGridReact
                ref={gridRef}
                showFooter={true}

                columnDefs={columnDefs}
                rowData={rowData}
                defaultColDef={defaultColDef}
                onToolPanelVisibleChanged={saveGridState}
                onColumnVisible={saveGridState} // When a column is shown/hidden
                onColumnPinned={saveGridState}   // When a column is pinned/unpinned
                onColumnMoved={saveGridState}
                rowSelection={'single'}
                suppressRowClickSelection={false}
                onColumnResized={saveGridState}
                onColumnRowGroupChanged={saveGridState}
                onSelectionChanged={handleSelectionChange}
                sideBar={{
                  toolPanels: [
                    {
                      id: 'columns',
                      labelDefault: 'Columns',
                      labelKey: 'columns',
                      iconKey: 'columns',
                      toolPanel: 'agColumnsToolPanel',
                    },
                    {
                      id: 'filters',
                      labelDefault: 'Filters',
                      labelKey: 'filters',
                      iconKey: 'filter',
                      toolPanel: 'agFiltersToolPanel',
                    },
                    // other tool panels as needed
                  ],
                  defaultToolPanel: null, // This will have the sidebar closed by default
                }}

                onGridReady={onGridReady}



              />
            </Box>
          </CardBody>
        </Card>

        {showFilters && (
        <VStack spacing={3} align="start"> {/* Wrap the date selection card in a VStack */}
        
        <Card height="auto">
          <CardHeader>
            <Text fontWeight="bold">
              Select Date Range
            </Text>
          </CardHeader>
          <CardBody>
              <FormLabel>Start Date</FormLabel>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                w="30%"
                customInput={<DateInput />}
                showTimeSelect
              />
              <FormLabel mt={2} >End Date</FormLabel>
              <DatePicker
                selected={endDate}
                customInput={<DateInput />}
                onChange={(date) => setEndDate(date)}
                showTimeSelect
              />
              <Button onClick={handleSearch} colorScheme="blue" w={'40%'} mt={3}>
                { searching ? <Spinner size={'sm'}/> : 'Search'}
              </Button>
          </CardBody>
        </Card>
        
        </VStack>
        )}
      </Grid>
        }
    </Box>
  );
}

export default Accounts;
